<template>
    <v-dialog v-model="dialog"
            persistent>
        <v-layout class="fill-height" fluid>
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4 elevation-0>
                    <v-card>
                        <v-toolbar>
                            <v-toolbar-title>Change Password</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-toolbar>
                        <v-card-text>
                            <v-form v-model="valid2"  ref="changeForm" lazy-validation>
                                <v-layout row>
                                    <v-text-field name="OldPassword"
                                        label="Old Password"
                                        v-model="oldpassword"
                                        type="password"
                                        :rules="[v => !!v || 'Old Password is required',]"
                                        hint="At least 6 characters with 1 symbol, 1 digit, 1 uppercase and 1 lowercase character"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row>
                                    <v-text-field name="NewPassword"
                                        label="New Password"
                                        v-model="newpassword"
                                        type="password"
                                        :rules="passwordRules"
                                        hint="At least 6 characters with 1 symbol, 1 digit, 1 uppercase and 1 lowercase character"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout row>
                                    <v-text-field name="ConfirmPassword"
                                        label="Confirm Password"
                                        v-model="confirmpassword"
                                        type="password"
                                        hint="Must match value entered in New Password"
                                        :rules="passwordConfirmationRules"
                                    ></v-text-field>
                                </v-layout>
                                <v-layout class="buttons" justify-end row align-center>
                                    <a style="text-decoration: none"
                                            class="align-center mr-4"
                                            @click="close">
                                        CANCEL
                                    </a>
                                    <v-btn color="success" 
                                            ml-2 mr-4 
                                            @click="changePassword"
                                            :disabled="!valid2">
                                        Change Password
                                    </v-btn>
                                </v-layout>
                            </v-form>
                        </v-card-text>
                    </v-card>            
                </v-flex>
            </v-layout>
        </v-layout>
    </v-dialog>
</template>

<script>
import axios from "axios";
import Bus from "../../bus";

export default {
    name: "ChangePassword",

    data: () =>({
        dialog: false,
        username: '',
        oldpassword: '',
        newpassword: '',
        confirmpassword: '',
        valid2: false,
    }),

    computed: {
        passwordRules(){
            return [
                v => !!v || 'New Password is required',
                v => (v.length >= 6) || 'Password must be at least 6 characters'
            ];
        },
        passwordConfirmationRules(){
            return [
                () => (this.newpassword === this.confirmpassword) || 'Passwords must match',
                v => !!v || 'Confirm Password is required'
            ];
        },
    },

    methods: {
        changePassword(){
            if(this.$refs.changeForm.validate())
            {
                axios.post('/api/User/ChangePassword/',
                    {
                        "Username": this.username,
                        "OldPassword": this.oldpassword,
                        "Password": this.newpassword,
                        "ConfirmPassword": this.confirmpassword
                    }
                ).then(response => {
                        Bus.$emit("alert", {
                        color: "success",
                        message: "Password reset successful!"
                        });

                        this.close();
                    }
                )
                .catch(function (error) {
                    Bus.$emit("alert", {
                        color: "error",
                        message: error.response.data.Message
                    });
                });
            }
        },
        open(){
            this.dialog = true;
            this.username = this.$store.state.auth.user;
        },
        close(){
            this.oldpassword = '';
            this.newpassword = '';
            this.confirmpassword = '';
            this.dialog = false;
        },
    },
}
</script>

<style scoped>
.buttons-bottom {
  position: fixed;
  bottom: 40px;
  right: 500px;
}
table.v-table tbody td,
table.v-table tbody th {
  height: 22px;
  font-size: 14px;
}

table.v-table tbody th {
  background-color: #4caf50;
}

table.v-table tbody tr:not(:last-child) {
  height: 22px;
  font-size: 14px;
}
.TierButton {
  border-color: #4caf50 !important;
  border-width: 1px !important;
  border-style: solid !important;
  color: #4caf50 !important;
  box-shadow: none !important;
  background-color: transparent !important;
}
.TierButton:hover {
  background-color: #4caf50 !important;
  color: white !important;
}
</style>